import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { schformcreate, schformdetail, schformupdate } from '../../../../services/superadmin';
import { useNavigate, useParams } from 'react-router-dom';
import dotracking from '../../../trackinglogs';
import trackobj from "../../../trackingpages.json"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { funderlist } from '../../../../services/master';
import Select from "react-select";

export const AddScholarship = () => {
    const { id } = useParams();
    const [curdate, setCurdate] = useState("");
    const [fid, setFID] = useState("");
    const [fname, setFName] = useState("");
    const [sdate, setSDate] = useState("");
    const [edate, setEDate] = useState("");
    const [status, setStatus] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [errmsg, setErrMsg] = useState("");
    const [lurl, setLUrl] = useState("");
    const [content, setContent] = useState("");
    const [funid, setFunId] = useState([]);
    const [flist, setFList] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setCurdate(moment(new Date()).format("YYYY-MM-DD"));
        if (id) {
            schformdetail(id).then((res) => {
                if (res.status === true) {
                    setFID(res.data.scholarship_form.id)
                    setFName(res.data.scholarship_form.form_name)
                    setSDate(res.data.scholarship_form.form_entry_start_date)
                    setEDate(res.data.scholarship_form.form_entry_end_date)
                    if (res.data.scholarship_form.form_info_content !== null) {
                        setContent(res.data.scholarship_form.form_info_content)

                    }
                    setStatus(res.data.scholarship_form.form_status == 1 ? true : false)
                    setLUrl(res.data.scholarship_form.form_url)
                }
            })
        } else {
            setFID("");
            setFName("");
            setSDate("");
            setEDate("");
            setStatus(true);
            setLUrl("");
            setContent("");
        }

        funderlist().then((res) => {
            if (res.status === true) {
                let arr = [];
                for (var i = 0; i < res.data.funders_list.length; i++) {
                    arr.push({
                        label: res.data.funders_list[i].funder_name,
                        value: res.data.funders_list[i].id,
                    });
                }
                setFList(arr);
            }
        });
    }, [id]);


    const handleEnds = (e) => {
        if (sdate !== "") {
            setEDate(e.target.value);
        } else {
            toast.error("Please Select Entry Start Date");
        }
    };
    function handleFun(e) {
        if (e === null) {
            setFunId([]);
        } else {
            setFunId(e);
        }
    }
    function backlist() {
        dotracking("back button in edit scholarship for " + fname + " (" + fid + ") $$ " + trackobj.schlistheading);
        navigate("/superadmin/scholarshipformlist")
    }
    function handlesubmit(e) {
        e.preventDefault();
        setSubmitted(true);
        if (fname !== "" && sdate !== "" && edate !== "" && content !== "") {
            setLoading(true);
            const temp = new FormData();
            temp.append('form_name', fname);
            temp.append('form_entry_start_date', sdate);
            temp.append('form_entry_end_date', edate);
            temp.append('form_status', status ? 1 : 0);
            temp.append('created_by', localStorage.getItem("UID"));
            temp.append('updated_by', localStorage.getItem("UID"));
            temp.append('form_info_content', content);

            const st = status ? 'Active' : 'Inactive'
            if (fid !== "") {
                temp.append('id', fid);
                dotracking("update button in update scholarship for " + fname + " , entry start date " + sdate + " , entry end date " + edate + " , status " + st + " $$ " + trackobj.schlistheading);
                schformupdate(temp).then((res) => {
                    if (res.status === true) {
                        setLoading(false);
                        toast.success(res.message);
                        navigate("/superadmin/scholarshipformlist")
                    } else {
                        setLoading(false);
                        setErrMsg(res.messgae)
                    }
                })
            } else {
                temp.append('funder_count', funid.length);
                for (let i = 0; i < funid.length; i++) {
                    temp.append('funder_id_' + (i + 1), funid[i].value);
                }
                dotracking("submit button in add scholarship for " + fname + " , entry start date " + sdate + " , entry end date " + edate + " , status " + st + " $$ " + trackobj.schlistheading);

                schformcreate(temp).then((res) => {
                    if (res.status === true) {
                        setLoading(false);
                        toast.success(res.message);
                        navigate("/superadmin/scholarshipformlist")
                    } else {
                        setLoading(false);
                        setErrMsg(res.messgae)
                    }
                })
            }


        }
    }

    function loginurl(ldata) {
        const url = window.location.href;
        const head = url.split("/#/");
        window.open(`${head[0]}/#/` + ldata, "_blank");
    }
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">{fid !== "" ? "Edit" : "Add"} Scholarship</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {fid !== "" ? "Edit" : "Add"} Scholarship
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="dashloader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading &&
                <div className="row">
                    <div className="card mt-0">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Form Name <span className="errortext"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Form Name"
                                            value={fname}
                                            onChange={(e) => setFName(e.target.value)}
                                        />
                                        {submitted && !fname && (
                                            <span className="errortext">
                                                Form Name is required
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Entry Start Date <span className="errortext"> *</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={sdate}
                                            // min={curdate}
                                            onChange={(e) => setSDate(e.target.value)}
                                            onKeyPress={(event) => {
                                                event.preventDefault();
                                            }}
                                            onKeyDown={(event) => {
                                                event.preventDefault();
                                            }}
                                        />
                                        {submitted && !sdate && (
                                            <span className="errortext">
                                                Entry Start Date is required
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Entry End Date <span className="errortext"> *</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={edate}
                                            min={sdate}
                                            onChange={handleEnds}
                                            onKeyPress={(event) => {
                                                event.preventDefault();
                                            }}
                                            onKeyDown={(event) => {
                                                event.preventDefault();
                                            }}
                                        />
                                        {submitted && !edate && (
                                            <span className="errortext">
                                                Entry End Date is required
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {!id &&
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">Funder</label>
                                            <Select
                                                className="dropdown"
                                                placeholder="Select Funder"
                                                value={funid}
                                                options={flist}
                                                onChange={handleFun}
                                                // onBlur={search}
                                                isSearchable={true}
                                                isMulti
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                }

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Status <span className="errortext"> *</span>
                                        </label>
                                        <div className="toggle-container mt-2">
                                            <label className="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={status}
                                                    onChange={() => setStatus(!status)}
                                                />
                                                <span className="slider"></span>
                                            </label>
                                            <span
                                                className={`toggle-label ${status ? "active" : "inactive"
                                                    }`}
                                            >
                                                {status ? "Active" : "Inactive"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Form Info Content <span className="errortext"> *</span>
                                        </label>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={content}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                setContent(data);
                                            }}
                                            config={{
                                                toolbar: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "underline",
                                                    "blockQuote",
                                                    "link",
                                                    "outdent",
                                                    "indent",
                                                    "numberedList",
                                                    "bulletedList",
                                                    "imageUpload",
                                                    "insertTable",
                                                    "|",
                                                    "undo",
                                                    "redo",
                                                    "specialCharacters",
                                                ],
                                            }}
                                        />
                                        {submitted && !content && (
                                            <span className="errortext">
                                                Form Info Content is required
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {id &&
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">
                                                Form URL
                                            </label>
                                            <span className="text-inverse">
                                                <a onClick={() => loginurl(lurl)} title={lurl}
                                                    className="btn btn-secondary"
                                                >
                                                    Click Here
                                                </a>
                                            </span>
                                        </div>


                                    </div>
                                }

                            </div>
                            {errmsg && <span className='text-danger'>{errmsg}</span>}
                        </div>
                        <div className="card-footer text-center border-top">
                            {fid !== "" &&
                                <button
                                    type="submit"
                                    className="btn btn-gray me-2"
                                    onClick={backlist}
                                >
                                    Back
                                </button>
                            }
                            <button
                                type="submit"
                                className="btn btn-success"
                                onClick={handlesubmit}
                            >
                                {fid !== "" ? "Update" : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            }

        </div>
    )
}
